import formatDate from '../formatDate';
/** @public */
const formatDates = (selectTwoDates, dates, format) => {
  const startDate = formatDate(dates.startDate, format);
  const endDate = formatDate(dates.endDate, format);
  if (selectTwoDates) {
    return startDate ? `${startDate} - ${endDate}` : null;
  }
  return startDate;
};
export default formatDates;